import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface Locale {
  lang: string;
  data: Record<string, any>;
}

export interface JsonTranslation {
  english: Record<string, any>;
  portuguese: Record<string, any>;
  spanish: Record<string, any>;
}

@Injectable({
  providedIn: 'root'
})
export class FuseTranslationLoaderService {
  constructor(private translateService: TranslateService) {}

  public loadTranslations(...locales: Locale[] | JsonTranslation[]): void {
    locales.forEach((locale) => {
      this.translateService.setTranslation(locale.lang, locale.data, true);
    });
  }

  public loadJsonTranslations({ english, portuguese, spanish }: JsonTranslation): void {
    this.loadTranslations(
      { lang: 'en', data: english },
      { lang: 'pt', data: portuguese },
      { lang: 'es', data: spanish }
    );
  }
}
